import React from 'react';
import Icons from '../../../components/icons';
import {
  FormFieldSchema,
  FormSchema
} from '../../../components/FormRenderer/types';
import timeUtils from '../../../utils/timeUtils';
import { OptionsProps } from '../../../components/MultiSelectWithAll/types';

export interface fieldProps {
  name: string;
  label: string;
  type: 'text' | 'date';
  placeholder?: string;
  disabled?: boolean;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
}

export const studentProfileSchema: FormSchema = [
  {
    name: 'studentDetails.emergencyContactDetails.emergencyContactNo',
    label: 'Emergency Contact No.',
    type: 'labelInputIcon',
    inputType: 'text',
    placeholder: 'Enter person name',
    startIcon: React.createElement(Icons.PhoneCall),
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: 'studentDetails.personalDetails.contactNo',
    label: 'Communication Number',
    type: 'labelInputIcon',
    inputType: 'text',
    placeholder: 'Phone or Email',
    startIcon: React.createElement(Icons.PhoneCall),
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: 'studentDetails.name',
    label: 'Name',
    type: 'labelInputIcon',
    inputType: 'text',
    placeholder: 'Enter Name',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: 'studentDetails.email',
    label: 'Email Id',
    type: 'labelInputIcon',
    inputType: 'text',
    placeholder: 'Email',
    startIcon: React.createElement(Icons.EnvelopeSimple),
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: 'studentDetails.emergencyContactDetails.emergencyContactPersonName',
    label: 'Emergency Contact Person',
    type: 'labelInputIcon',
    inputType: 'text',
    placeholder: 'Name',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: 'studentDetails.emergencyContactDetails.relationWithStudent',
    label: 'Relationship',
    type: 'labelInputIcon',
    inputType: 'text',
    placeholder: 'Relationship',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: 'studentDetails.enrollmentNo',
    label: 'Enrollment No',
    type: 'labelInputIcon',
    inputType: 'text',
    placeholder: 'Enrolment No',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: 'studentDetails.personalDetails.bloodGroup',
    label: 'Blood Group',
    type: 'labelInputIcon',
    inputType: 'text',
    placeholder: 'Blood Group',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: 'studentDetails.personalDetails.motherTongue',
    label: 'Speaks',
    type: 'labelInputIcon',
    inputType: 'text',
    placeholder: 'Languages',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: 'studentDetails.personalDetails.residentialAddress',
    label: 'Address',
    type: 'labelInputIcon',
    inputType: 'text',
    placeholder: 'Address',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  }
];
export function studentAcademicInfoSchema(
  divisionOptions: OptionsProps[],
  activityGroups: OptionsProps[]
): FormSchema {
  return [
    {
      name: 'studentDetails.currentCourseInfo.grade',
      label: 'Grade',
      type: 'labelInputIcon',
      inputType: 'text',
      placeholder: 'Grade',
      disabled: true,
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
    },
    {
      name: 'studentDetails.currentCourseInfo.division',
      label: 'Division',
      type: 'dropdown',
      options: divisionOptions,
      hasTopLabel: true,
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
    },
    {
      name: 'studentDetails.currentCourseInfo.section',
      label: 'Section',
      type: 'labelInputIcon',
      inputType: 'text',
      placeholder: 'Section',
      disabled: true,
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
    },
    {
      name: 'studentDetails.currentCourseInfo.house',
      label: 'House',
      type: 'labelInputIcon',
      inputType: 'text',
      placeholder: 'Enter House',
      required: false,
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
    },
    {
      name: 'studentDetails.currentCourseInfo.rollNo',
      label: 'Roll No',
      type: 'labelInputIcon',
      inputType: 'text',
      placeholder: 'Enter roll No',
      required: false,
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
    },
    {
      name: 'studentDetails.currentCourseInfo.academicYear.from',
      label: 'AY Start Date',
      type: 'labelInputIcon',
      inputType: 'text',
      placeholder: 'AY Start Date',
      disabled: true,
      transformBeforeRender: (value) => {
        if (!value) return '';

        return timeUtils.transformDateToYearMonthDate(value);
      },

      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
    },
    {
      name: 'studentDetails.currentCourseInfo.academicYear.to',
      label: 'AY End Date',
      type: 'labelInputIcon',
      inputType: 'text',
      placeholder: 'AY End Date',
      disabled: true,
      transformBeforeRender: (value) => {
        if (!value) return '';

        return timeUtils.transformDateToYearMonthDate(value);
      },
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
    },
    {
      name: 'studentDetails.currentCourseInfo.activityClubs',
      label: 'Activity Clubs',
      type: 'multiSelect',
      options: activityGroups,
      hasTopLabel: true,
      required: false,
      placeholder: 'Select Activity Club',
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
    }
  ];
}

export const studentMiscellaneousInfoSchema = (
  loggedInUser: any,
  customFieldMapping: Record<string, string> = {}
): FormSchema => {
  const customFieldEntries: FormFieldSchema[] = Object.entries(
    customFieldMapping
  ).map(([key, label]) => ({
    name: `studentDetails.customFieldsMap.${key}`,
    required: false,
    label,
    type: 'labelInputIcon',
    inputType: 'text',
    placeholder: `Enter ${label}`,
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  }));

  return [
    {
      name: 'studentDetails.personalDetails.religion',
      label: 'Religion',
      type: 'labelInputIcon',
      inputType: 'text',
      placeholder: 'Enter Religion',
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
    },
    {
      name: 'studentDetails.personalDetails.caste',
      label: 'Caste',
      type: 'labelInputIcon',
      inputType: 'text',
      placeholder: 'Enter Caste',
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
    },
    {
      name: 'studentDetails.personalDetails.birthPlace',
      label: 'Place Of Birth',
      type: 'labelInputIcon',
      inputType: 'text',
      placeholder: 'Enter Place Of Birth',
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
    },
    {
      name: 'studentDetails.personalDetails.dateOfBirth',
      label: 'Date Of Birth',
      type: 'labelInputIcon',
      inputType: 'date',
      placeholder: 'Enter Date Of Birth',
      endIcon: React.createElement(Icons.Calendar),
      transformBeforeRender: (value) => {
        if (!value) return '';

        return timeUtils.transformDateToYearMonthDate(value);
      },
      transformAfterInput: (value) => {
        if (!value) return null;
        return new Date(`${value}T00:00:00.000Z`).toISOString();
      },
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
    },
    {
      name: 'studentDetails.officialDetails.adhaarCardNo',
      label: 'Aadhaar',
      type: 'labelInputIcon',
      inputType: 'text',
      placeholder: 'Enter Aadhaar',
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
    },
    {
      name: 'studentDetails.personalDetails.nationality',
      label: 'Nationality',
      type: 'labelInputIcon',
      inputType: 'text',
      placeholder: 'Enter Nationality',
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
    },
    {
      name: 'studentDetails.officialDetails.passportExpiryDate',
      required: false,
      label: 'Passport Expiry',
      type: 'labelInputIcon',
      inputType: 'date',
      placeholder: 'Enter Expiry Date',
      endIcon: React.createElement(Icons.Calendar),
      transformBeforeRender: (value) => {
        if (!value) return '';

        return timeUtils.transformDateToYearMonthDate(value);
      },
      transformAfterInput: (value) => {
        if (!value) return null;
        return new Date(`${value}T00:00:00.000Z`).toISOString();
      },
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
    },
    {
      name: 'studentDetails.personalDetails.country',
      required: false,
      label: 'Country',
      type: 'labelInputIcon',
      inputType: 'text',
      placeholder: 'Enter Country',
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
    },
    {
      name: 'studentDetails.permanentEducationNumber',
      label: 'PEN',
      type: 'labelInputIcon',
      inputType: 'text',
      placeholder: 'Enter PEN',
      required: false,
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
    },
    {
      name: 'studentDetails.apaarId',
      label: 'Apaar Id',
      type: 'labelInputIcon',
      inputType: 'text',
      placeholder: 'Enter Apaar Id',
      required: false,
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
    },
    {
      name: 'studentDetails.gender',
      label: 'Gender',
      type: 'labelInputIcon',
      inputType: 'text',
      placeholder: 'Enter Gender',
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
    },
    {
      name: 'studentDetails.officialDetails.passportNo',
      label: 'Passport No',
      type: 'labelInputIcon',
      inputType: 'text',
      placeholder: 'Enter password number',
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
    },
    ...customFieldEntries,
    {
      name: 'studentDetails.officialDetails.visa',
      label: 'OCI / Visa',
      type: 'labelInputIcon',
      inputType: 'text',
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
    },

    {
      name: 'studentDetails.dateOfJoining',
      label: 'Date Of Joining',
      type: 'labelInputIcon',
      inputType: 'date',
      placeholder: 'Enter Date Of Joining',
      endIcon: React.createElement(Icons.Calendar),
      transformBeforeRender: (value) => {
        if (!value) return '';

        return timeUtils.transformDateToYearMonthDate(value);
      },
      transformAfterInput: (value) => {
        if (!value) return null;
        return new Date(`${value}T00:00:00.000Z`).toISOString();
      },
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
    },

    {
      name: 'studentDetails.previousSchoolAttended',
      required: false,
      label: 'Previous School Attended',
      type: 'labelInputIcon',
      inputType: 'text',
      placeholder: 'Enter Previous School Name',
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
    },
    {
      name: 'studentDetails.firstAdmissionClass',
      required: false,
      label: 'First Admission Class',
      type: 'labelInputIcon',
      inputType: 'text',
      placeholder: 'Enter First Admission Class',
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
    },
    {
      name: 'studentDetails.personalDetails.resCity',
      required: false,
      label: 'Resident City',
      type: 'labelInputIcon',
      inputType: 'text',
      placeholder: 'Enter City',
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 },
      shouldRender: () => loggedInUser.school === 'BPIS'
    },
    {
      name: 'studentDetails.personalDetails.resPincode',
      required: false,
      label: 'Pincode',
      type: 'labelInputIcon',
      inputType: 'text',
      placeholder: 'Enter Pincode',
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 },
      shouldRender: () => loggedInUser.school === 'BPIS'
    },
    {
      name: 'studentDetails.personalDetails.minority',
      required: false,
      label: 'Minority',
      type: 'labelInputIcon',
      inputType: 'text',
      placeholder: 'Enter Minority',
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 },
      shouldRender: () => loggedInUser.school === 'BPIS'
    },
    {
      name: 'studentDetails.personalDetails.birthCountry',
      required: false,
      label: 'Birth Country',
      type: 'labelInputIcon',
      inputType: 'text',
      placeholder: 'Enter Birth Country',
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 },
      shouldRender: () => loggedInUser.school === 'BPIS'
    },
    {
      name: 'studentDetails.personalDetails.birthState',
      required: false,
      label: 'Birth State',
      type: 'labelInputIcon',
      inputType: 'text',
      placeholder: 'Enter Birth State',
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 },
      shouldRender: () => loggedInUser.school === 'BPIS'
    },
    {
      name: 'studentDetails.personalDetails.birthDistrict',
      required: false,
      label: 'Birth District',
      type: 'labelInputIcon',
      inputType: 'text',
      placeholder: 'Enter Birth District',
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 },
      shouldRender: () => loggedInUser.school === 'BPIS'
    },
    {
      name: 'studentDetails.personalDetails.birthCity',
      required: false,
      label: 'Birth City',
      type: 'labelInputIcon',
      inputType: 'text',
      placeholder: 'Enter Birth City',
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 },
      shouldRender: () => loggedInUser.school === 'BPIS'
    },
    {
      name: 'studentDetails.personalDetails.birthTaluka',
      required: false,
      label: 'Birth Taluka',
      type: 'labelInputIcon',
      inputType: 'text',
      placeholder: 'Enter Birth Taluka',
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 },
      shouldRender: () => loggedInUser.school === 'BPIS'
    },
    {
      name: 'studentDetails.personalDetails.weight',
      required: false,
      label: 'Weight',
      type: 'labelInputIcon',
      inputType: 'text',
      placeholder: 'Enter Weight',
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 },
      shouldRender: () => loggedInUser.school === 'BPIS'
    },
    {
      name: 'studentDetails.personalDetails.height',
      required: false,
      label: 'Height',
      type: 'labelInputIcon',
      inputType: 'text',
      placeholder: 'Enter Height',
      gridProps: { xs: 12, sm: 6, md: 4, lg: 3 },
      shouldRender: () => loggedInUser.school === 'BPIS'
    }
  ];
};

export const studentHealthInfoSchema: FormSchema = [
  {
    name: 'studentDetails.studentHealthInfo.medicationDetails',
    label: 'Medication',
    type: 'labelInputIcon',
    inputType: 'text',
    placeholder: 'Enter Medication',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: 'studentDetails.studentHealthInfo.allergyDetails',
    label: 'Allergies',
    type: 'labelInputIcon',
    inputType: 'text',
    placeholder: 'Enter Allergies',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: 'studentDetails.studentHealthInfo.medicalProblemDetails',
    label: 'Concerns',
    type: 'labelInputIcon',
    inputType: 'text',
    placeholder: 'Enter Concerns',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: 'studentDetails.medicalPractitionerInfo.name',
    label: 'Dr. Name',
    type: 'labelInputIcon',
    inputType: 'text',
    placeholder: 'Enter Doctor Name',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: 'studentDetails.medicalPractitionerInfo.mobileNo',
    label: 'Dr. Mobile',
    type: 'labelInputIcon',
    inputType: 'text',
    placeholder: 'Enter Doctor Mobile Number',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: 'studentDetails.medicalPractitionerInfo.address',
    label: 'Dr. Address',
    type: 'labelInputIcon',
    inputType: 'text',
    placeholder: 'Enter Doctor Mobile Address',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: 'studentDetails.medicalPractitionerInfo.clinicPhoneNo',
    label: 'Dr. Landline',
    type: 'labelInputIcon',
    inputType: 'text',
    placeholder: 'Enter Doctor Landline Number',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  }
];

export const familyBasicInfoSchema = (parentKey: string): FormSchema => [
  {
    name: `${parentKey}.name`,
    label: 'Full Name',
    type: 'labelInputIcon',
    inputType: 'text',
    placeholder: 'Enter Full Name',
    gridProps: { xs: 12, sm: 6, md: 4 }
  },
  {
    name: `${parentKey}.personalDetails.contactNo`,
    label: 'Mobile No',
    type: 'labelInputIcon',
    inputType: 'text',
    placeholder: 'Enter Mobile Number',
    gridProps: { xs: 12, sm: 6, md: 4 }
  },
  {
    name: `${parentKey}.occupationDetails.officeContactNo`,
    label: 'Office Contact No',
    type: 'labelInputIcon',
    inputType: 'text',
    placeholder: 'Enter Office Contact Number',
    gridProps: { xs: 12, sm: 6, md: 4 }
  }
];

export const familyInfoSchema = (parentKey: string): FormSchema => [
  {
    name: `${parentKey}.email`,
    label: 'Email Id',
    type: 'labelInputIcon',
    inputType: 'text',
    placeholder: 'Enter Email',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: `${parentKey}.occupationDetails.isGovermentEmployee`,
    label: 'Govt Employee',
    placeholder: 'Select Govt Employee Status',
    type: 'dropdown',
    options: [
      { label: 'Yes', value: 'true' },
      { label: 'No', value: 'false' }
    ],
    hasTopLabel: true,
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: `${parentKey}.occupationDetails.profession`,
    label: 'Profession',
    placeholder: 'Enter Profession',
    type: 'labelInputIcon',
    inputType: 'text',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: `${parentKey}.occupationDetails.occupation`,
    label: 'Occupation',
    placeholder: 'Enter Occupation',
    type: 'labelInputIcon',
    inputType: 'text',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: `${parentKey}.occupationDetails.designation`,
    label: 'Designation',
    placeholder: 'Enter Designation',
    type: 'labelInputIcon',
    inputType: 'text',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: `${parentKey}.occupationDetails.organizationName`,
    label: 'Organization',
    placeholder: 'Enter Organization Name',
    type: 'labelInputIcon',
    inputType: 'text',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: `${parentKey}.occupationDetails.officeAddress`,
    label: 'Office Address',
    placeholder: 'Enter Office Address',
    type: 'labelInputIcon',
    inputType: 'text',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: `${parentKey}.occupationDetails.websiteOrLinkedInProfileUrl`,
    label: 'Website',
    placeholder: 'Enter Website URL',
    type: 'labelInputIcon',
    inputType: 'text',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: `${parentKey}.occupationDetails.annualIncome`,
    label: 'Annual Income',
    placeholder: 'Enter Annual Income',
    type: 'labelInputIcon',
    inputType: 'text',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: `${parentKey}.educationalQualification`,
    label: 'Qualification',
    placeholder: 'Enter Educational Qualification',
    type: 'labelInputIcon',
    inputType: 'text',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: `${parentKey}.officialDetails.adhaarCardNo`,
    label: 'Aadhaar',
    placeholder: 'Enter Aadhaar Number',
    type: 'labelInputIcon',
    inputType: 'text',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: `${parentKey}.officialDetails.panCardNo`,
    label: 'PAN Card',
    placeholder: 'Enter PAN Card Number',
    type: 'labelInputIcon',
    inputType: 'text',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  }
];

export const GuardianBasicInfoSchema: FormSchema = [
  {
    name: `studentDetails.guardianInfo.name`,
    label: 'Full Name',
    type: 'labelInputIcon',
    inputType: 'text',
    placeholder: 'Enter Full Name',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: `studentDetails.guardianInfo.personalDetails.contactNo`,
    label: 'Mobile No',
    type: 'labelInputIcon',
    inputType: 'text',
    placeholder: 'Enter Mobile Number',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: `studentDetails.guardianInfo.occupationDetails.officeContactNo`,
    label: 'Office Contact No',
    type: 'labelInputIcon',
    inputType: 'text',
    placeholder: 'Enter Office Contact Number',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  }
];

export const GuardianInfoSchema: FormSchema = [
  {
    name: `studentDetails.guardianInfo.emailId`,
    label: 'Email Id',
    type: 'labelInputIcon',
    inputType: 'text',
    placeholder: 'Enter Email',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: `studentDetails.guardianInfo.occupationDetails.isGovermentEmployee`,
    label: 'Govt Employee',
    placeholder: 'Select Govt Employee Status',
    type: 'dropdown',
    options: [
      { label: 'Yes', value: 'true' },
      { label: 'No', value: 'false' }
    ],
    hasTopLabel: true,
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: `studentDetails.guardianInfo.occupationDetails.profession`,
    label: 'Profession',
    placeholder: 'Enter Profession',
    type: 'labelInputIcon',
    inputType: 'text',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: `studentDetails.guardianInfo.occupationDetails.occupation`,
    label: 'Occupation',
    placeholder: 'Enter Occupation',
    type: 'labelInputIcon',
    inputType: 'text',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: `studentDetails.guardianInfo.occupationDetails.designation`,
    label: 'Designation',
    placeholder: 'Enter Designation',
    type: 'labelInputIcon',
    inputType: 'text',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: `studentDetails.guardianInfo.occupationDetails.organizationName`,
    label: 'Organization',
    placeholder: 'Enter Organization Name',
    type: 'labelInputIcon',
    inputType: 'text',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: `studentDetails.guardianInfo.occupationDetails.officeAddress`,
    label: 'Office Address',
    placeholder: 'Enter Office Address',
    type: 'labelInputIcon',
    inputType: 'text',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: `studentDetails.guardianInfo.occupationDetails.websiteOrLinkedInProfileUrl`,
    label: 'Website',
    placeholder: 'Enter Website URL',
    type: 'labelInputIcon',
    inputType: 'text',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: `studentDetails.guardianInfo.occupationDetails.annualIncome`,
    label: 'Annual Income',
    placeholder: 'Enter Annual Income',
    type: 'labelInputIcon',
    inputType: 'text',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: `studentDetails.guardianInfo.educationalQualification`,
    label: 'Qualification',
    placeholder: 'Enter Educational Qualification',
    type: 'labelInputIcon',
    inputType: 'text',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: `studentDetails.guardianInfo.officialDetails.adhaarCardNo`,
    label: 'Aadhaar',
    placeholder: 'Enter Aadhaar Number',
    type: 'labelInputIcon',
    inputType: 'text',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  },
  {
    name: `studentDetails.guardianInfo.officialDetails.panCardNo`,
    label: 'PAN Card',
    placeholder: 'Enter PAN Card Number',
    type: 'labelInputIcon',
    inputType: 'text',
    gridProps: { xs: 12, sm: 6, md: 4, lg: 3 }
  }
];
